import { fetchBaseQuery, createApi } from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({
  baseUrl: "",
  prepareHeaders: (headers, { getState }) => {
    // Get token from state
    const token = getState().auth.userInfo?.token;

    // If we have a token, include it in the Authorization header
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }

    return headers;
  },
});

export const apiSlice = createApi({
  baseQuery,
  tagTypes: [
    "User",
    "Program",
    "Programs",
    "ParentalRating",
    "Genre",
    "Subgenre",
    "TemplateDates",
    "TemplatePrograms",
    "PlaylistPrograms",
    "Idents",
    "Graphics",
    "Songs",
    "AddsPromos",
    "SongContacts",
    "EPGData",
  ],
  endpoints: (builder) => ({}),
});
